import login from './login'
import nav from './_nav.json'
import activity from './activity'
import dict from './dict.json'
import demo from './demo.json'

export default {
  site_title: 'bailesson.com',
  title: '赛事活动发布系统', // 网站标题
  system_demo: '系统演示',
  confirm: '确定',
  cancel: '取消',
  show: '显示',
  hide: '不显示',
  open: '开启',
  close: '关闭',
  search: '搜索',
  delete: '删除',
  edit: '编辑',
  add: '新增',
  save: '保存',
  submit: '提交',
  reset: '重置',
  started: '已开始',
  ended: '已结束',
  next: '下一步',
  prev: '上一步',
  publish: '发布',
  input: '请输入{text}',
  select: '请选择{text}',
  required: '{text}不能为空',
  selected: '已选 {total} {text}',
  create: '新建',
  free: '免费',
  charge: '收费',
  default: '默认',
  custom: '自定义',
  max: '最大数',
  min: '最小数',
  percent: '百分比',
  online: '线上',
  offline: '线下',
  name: '名称',
  remark: '备注',
  tips: '温馨提示',
  total: '共{ total }条',
  price: '{price}元',
  // 头部导航
  header: {
    // 退出
    logout: '退出',
    binding: '绑定账号',
    // 移动端
    mobile: '移动管理端',
    // 报名
    register: '移动报名端',
    tips: '活动赛事{name}',
    qrcodeText: '{name}H5二维码',
    qrcodeMiniText: '{name}小程序码',
    // 二维码
    qrcode: '点击下载二维码',
    // 小程序码
    qrcodeMini: '点击下载小程序码'
  },
  home: {
    title: '欢迎来到 筋斗云活动管理平台',
    sub_title: '发布最完善细致的赛事、会务活动尽在此',
    desc: '从活动管理开始你的活动举办之旅',
    create: '快速创建活动'
  },
  user: {
    title: '账户基本信息',
    logo: '品牌Logo',
    update: '更新',
    name: '企业或机构名称',
    short_name: '左上菜单栏品牌',
    enable: '开启个性化登录',
    // 个性化登录网址
    web_tips: '个性化登录网址',
    copy: '复制网址',
    // 登录页品牌名称
    login: '登录页品牌名称',
    // 登录页系统名称
    login_title: '登录页系统名称'
  },
  // 导航
  login,
  activity,
  demo,
  ...nav,
  ...dict,
  // 状态码本地化
  // 返回操作成功
  // CODE_SUCCESS: 2000,
  2000: '操作请求成功',
  // 返回错误
  // CODE_ERROR: 5000,
  5000: '网络请求异常，请检查网络',
  // 参数错误
  // CODE_ERROR_PARAMS: 5001,
  5001: '请求参数错误',
  // URL注册失败
  // CODE_ERROR_URL_REG_FAILURE: 5002,
  5002: 'URL注册失败',
  // 参数错误
  // CODE_ERROR_NO_PARAM: 5003,
  5003: '参数错误',
  // 权限错误
  // CODE_ERROR_PERSSION_ERROR: 5004,
  5004: '权限错误',
  // JWT 验证错误
  // CODE_JWT_ERROR: 5100,
  5100: 'JWT 验证失败',
  // 登录失败
  // CODE_JWT_LOGIN_FAILURE: 5101,
  5101: '登录失败',
  // JWT Token 无效
  // CODE_JWT_TOKEN_INVALID: 5102,
  5102: 'JWT 无效',
  // 无任何用户
  // CODE_JWT_NO_USER: 5103,
  5103: '用户不存在',
  //
  // CODE_PARAMS_TYPE_ERROR_SIZE = 5401
  5401: 'size 参数出错',
  //
  // CODE_PARAMS_TYPE_ERROR_PAGE = 5402
  5402: 'page 参数出错',
  //
  // CODE_PARAMS_TYPE_ERROR_QUERY = 5403
  5403: '查询关键字出错'
}



// WEBPACK FOOTER //
// ./src/langs/zh_cn/index.js